module.exports = __webpack_public_path__ + "static/img/9.dae0b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/9.jpg
// module id = O6oy
// module chunks = 0